import React from 'react';
import { Toast } from 'antd-mobile';
import './index.less';

class Attachment extends React.Component {
    constructor(props) {
        super(props);
        // console.log(props.fileData)
        this.state = {
            data: props.fileData && props.fileData !== 'null' ? props.fileData : []
        };
    }

    fileType(name){
        const jpg = "jpg|jpeg";
        const png = "png";
        const word = 'doc|docx';
        const excel = 'xls|xlsx';
        const pdf = 'pdf';
        const ppt = 'ppt|pptx';
        const rar = 'rar';
        const zip = 'zip';
        const patternJpg = new RegExp(".(" + jpg + ")$");
        const patternPng = new RegExp(".(" + png + ")$");
        const patternWord = new RegExp(".(" + word + ")$");
        const patternExcel = new RegExp(".(" + excel + ")$");
        const patternPdf = new RegExp(".(" + pdf + ")$");
        const patternPpt = new RegExp(".(" + ppt + ")$");
        const patternRar = new RegExp(".(" + rar + ")$");
        const patternZip = new RegExp(".(" + zip + ")$");
        if(name.indexOf('?')>-1){
            name = name.split('?')[0];
        }

        if (patternJpg.test(name)) {
            return "JPG";
        }
        else if(patternPng.test(name)) {
            return "PNG";
        }
        else if(patternWord.test(name)) {
            return "WORD";
        }
        else if(patternExcel.test(name)) {
            return "EXCEL";
        }
        else if(patternPdf.test(name)) {
            return "PDF";
        }
        else if(patternPpt.test(name)) {
            return "PPT";
        }
        else if(patternRar.test(name)) {
            return "RAR";
        }
        else if(patternZip.test(name)) {
            return "ZIP";
        }
    }

    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是否web应该程序，没有头部与底部
        };
    }

    appShare(ops, shareType) {
        let viewPort = this.viewPort();
        if (
            viewPort.ios ||
            viewPort.iPhone ||
            viewPort.iPad
        ) {
            if(window.webkit){
                if(shareType === 'open'){
                    window.webkit.messageHandlers.openNewUrl.postMessage(ops);
                }else{
                    window.webkit.messageHandlers.downloadFile.postMessage(ops);
                }
            }
        } else {
            if(window.huilian){
                if(shareType === 'open'){
                    window.huilian.openNewUrl(ops);
                }else{
                    window.huilian.downloadFile(JSON.stringify(ops));
                }
            }
        }
    }

    render() {
        const {data} = this.state;
        const _this = this;
        // console.log(data)
        return (
            <div className="AttachmentBox">
                {
                    data.length > 0 ? data.map((item, index)=>{
                        const fileType = this.fileType(item.dataImg);
                        return (
                            <div key={'file_'+index} className="fileBox">
                                <i className={'fileType ' + fileType}>{fileType}</i>
                                <div className="fileName" onClick={()=>{
                                    const fileType = _this.fileType(item.dataImg);
                                    if(fileType === 'RAR' || fileType === 'ZIP'){
                                        Toast.offline('压缩文件不支持预览！', 1);
                                        return;
                                    }
                                    this.appShare(`https://file-preview.hellogil.com/onlinePreview?url=${item.dataImg.replace('http://','https://')}`, 'open');
                                }}>{item.imgName}</div>
                                <i className="downloadBtn" onClick={()=>{
                                    this.appShare(item);
                                }}></i>
                            </div>
                        )
                    }) : ''
                }
            </div>
        );
    }
}

export default Attachment;


// WEBPACK FOOTER //
// ./src/processReview/modules/attachment/index.js